var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 136,
    viewBox: "0 0 139 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.82 87.4556L61.5212 66.8816L80.4462 57.4222L61.5212 47.9629L52.82 27.3889L44.1188 47.9629L25.1937 57.4222L44.1188 66.8816L52.82 87.4556ZM52.82 114.844L36.3137 75.3667L0 57.4222L36.3137 39.4778L52.82 0L69.3263 39.4778L105.64 57.4222L69.3263 75.3667L52.82 114.844ZM112.59 136L104.424 116.167L86.18 107.289L104.424 98.2222L112.59 78.5778L120.93 98.2222L139 107.289L120.93 116.167L112.59 136Z",
    fill: "#F8FD05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1be483842bf25c5be5348adbe8bb6a31.svg";
export { ForwardRef as ReactComponent };